import { ReactComponent as Building } from './assets/building.svg'
import { ReactComponent as ChevronDown } from './assets/chevron-down.svg'
import { ReactComponent as ChevronRight } from './assets/chevron-right.svg'
import { ReactComponent as CurrencyDollarCircle } from './assets/currency-dollar-circle.svg'
import { ReactComponent as Edit } from './assets/edit.svg'
import { ReactComponent as Logout } from './assets/logout.svg'
import { ReactComponent as Plus } from './assets/plus.svg'
import { ReactComponent as Receipt } from './assets/receipt.svg'
import { ReactComponent as ReceiptCheck } from './assets/receipt-check.svg'
import { ReactComponent as Search } from './assets/search.svg'
import { ReactComponent as Trash } from './assets/trash.svg'
import { ReactComponent as Upload } from './assets/upload.svg'
import { ReactComponent as User } from './assets/user.svg'
import { ReactComponent as ValleyLogo } from './assets/valley-logo.svg'

export const icons = {
  Building,
  ChevronDown,
  ChevronRight,
  CurrencyDollarCircle,
  Edit,
  Logout,
  Plus,
  Receipt,
  ReceiptCheck,
  Search,
  Trash,
  Upload,
  User,
  ValleyLogo,
}
